export const getIconClass = (icon: string) => {
    if (icon && icon.split(' ').length === 1 && !icon.startsWith('dx-icon-')) {
        return `dx-icon-${icon}`
    } else {
        return icon
    }
}
